/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./GroupClassSelectForm.vue?vue&type=template&id=34ea1571&scoped=true&"
import script from "./GroupClassSelectForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./GroupClassSelectForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./GroupClassSelectForm.vue?vue&type=style&index=0&id=34ea1571&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ea1571",
  null
  
)

export default component.exports